import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

const CardStyle = styled('div', {
  static: {
    borderRadius: 4,
    boxSizing: 'border-box',
    border: '0.0625rem solid',
    borderColor: '$gray4',
    backgroundColor: '#FEFEFE',
    boxShadow: '0 0.125rem 0.3125rem 0 rgba(0,0,0,0.05)',
  },
  dynamic: ({ fullHeight, position }) => ({
    return: {
      height: fullHeight ? '100%' : null,
      position,
    },
  }),
});

export const Card = CardStyle;

Card.propTypes = {
  fullHeight: PropTypes.bool,
};

Card.defaultProps = {
  fullHeight: false,
};
